import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../utils/api";
import axiosInstance from "../../../utils/axiosConfig";
import { RootState } from "../../rootReducer";

export const findTemplatesMassiveDocumments = createAsyncThunk(
  "templateListMassiveDocummentCreate/find",
  async (data, { rejectWithValue, getState }) => {
    const state = getState() as RootState;

    try {

      const { data } = await axiosInstance.get(
        `${api.baseURL}form?select=id,name&where={"assignedTo":"", "sourceOrganization":"${state.userAuthentication.user?.sourceOrganization}"}&limit=-1`
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
